import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import type { ThemeWithOptionalSetterProps } from "types";

const balls = [
  { bg: "#ff005d", dir: "right" as const },
  { bg: "#35ff99", dir: "left" as const },
  { bg: "#008597", dir: "right" as const },
  { bg: "#ffcc00", dir: "left" as const },
  { bg: "#2d3443", dir: "right" as const },
  { bg: "#ff7c35", dir: "left" as const },
  { bg: "#4d407c", dir: "right" as const },
];

const ballSpeeds = ["1s", "1.1s", "1.05s", "1.15s", "1.1s", "1.05s", "1s"];

const AnimatedSplash: React.FC = () => (
  <div className="h-[50vh] w-full flex items-center justify-center mt-[20%] max-w-5xl mx-auto px-4">
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
      {balls.map((ball, i) => (
        <div
          key={i}
          className="w-[90px] h-[10px] my-[7px] mx-auto rounded-[50px]"
          style={{
            backgroundColor: ball.bg,
            animation: `${ball.dir} ${ballSpeeds[i]} infinite ease-in-out`,
          }}
        />
      ))}
    </div>

    <style>{`
      @keyframes right {
        0%, 100% { transform: translateX(-15px); }
        50% { transform: translateX(15px); }
      }
      @keyframes left {
        0%, 100% { transform: translateX(15px); }
        50% { transform: translateX(-15px); }
      }
    `}</style>
  </div>
);

const Splash: React.FC<ThemeWithOptionalSetterProps> = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const id = setTimeout(() => navigate("/home"), 2000);
    return () => clearTimeout(id);
  }, [navigate]);

  return <AnimatedSplash />;
};

export default Splash;
